import React, { useState, useEffect } from 'react';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dropdown from 'react-bootstrap/Dropdown';

function CreateParameterTestModal(props) {
    const [parameterName, setParameterName] = useState(props.parameterName || "");
    const [startValue, setStartValue] = useState(props.startValue || 0);
    const [endValue, setEndValue] = useState(props.endValue || 0);
    const [increment, setIncrement] = useState(1);

    function isInt(n) {
        return Number(n) === n && n % 1 === 0;
    }

    useEffect(() => {
        const sValue = props.startValue || 0;
        const eValue = props.endValue || 0;
        setParameterName(props.parameterName || "");
        setStartValue(sValue);
        setEndValue(eValue);
        setIncrement(!isInt(Number(sValue)) || !isInt(Number(eValue)) ? 0.1 : 1);
    }, [props.isOpen, props.parameterName, props.startValue, props.endValue]);

    async function handleSubmit() {
        console.log("handleSubmit for parameter sensitivity test");
        const url = `/api/strategyAlertCreateParameterSensitivityTest?alertId=${props.alertId}&parameterName=${parameterName}&startValue=${startValue}&endValue=${endValue}&increment=${increment}`;
        console.log(url);
        const r = await (await fetch(url, { method: 'POST' })).json();
        console.log(r);
        if (props.onClose) {
            props.onClose(r);
        }
    }

    function handleModalClosed() {
        if (props.onClose) {
            props.onClose(null);
        }
    }

    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    return (
        <>
            <Modal
                aria-labelledby="create-parameter-test-modal-title"
                aria-describedby="create-parameter-test-modal-description"
                open={props.isOpen}
                onClose={() => handleModalClosed()}
            >
                <Box sx={modalStyle}>
                    <Typography id="create-parameter-test-modal-title" variant="h6" component="h2">
                        Create Parameter Sensitivity Test
                    </Typography>
                    <Typography id="create-parameter-test-modal-description" sx={{ mt: 2 }}>
                        Parameter Name: {parameterName}
                        <br /><br />
                        Start Value: <input type="number" value={startValue} onChange={(e) => setStartValue(e.target.value)} />
                        <br /><br />
                        End Value: <input type="number" value={endValue} onChange={(e) => setEndValue(e.target.value)} />
                        <br /><br />
                        <div className="sameline">
                            Increment:&nbsp;&nbsp;
                            <Dropdown onSelect={(e) => setIncrement(e)}>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    {increment}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey={0.1}>0.1</Dropdown.Item>
                                    <Dropdown.Item eventKey={1}>1</Dropdown.Item>
                                    <Dropdown.Item eventKey={5}>5</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <br /><br />
                        <button className="btn btn-primary" onClick={handleSubmit} type="button">Submit</button>
                    </Typography>
                </Box>
            </Modal>
        </>
    );
}

export default CreateParameterTestModal;